<template>
  <div class="contact-form-container">
    <div class="intro">
      {{ labels.get("Form intro") }}
    </div>
    <div class="contact-info" v-if="foundDetails">
      <ContactCard :contact="foundDetails"></ContactCard>
      <div class="spacer"></div>
      <FlatButton
        secondary
        :label="labels.get('Different contact')"
        @click="onRewind"
        class="different-contact white"
      ></FlatButton>
    </div>
    <ContactFormGeneral
      ref="generalForm"
      v-if="
        foundDetails &&
          !utils.contactBelongsToBU(config.icsTagId, foundDetails) &&
          !utils.contactBelongsToBU(config.catalystsTagId, foundDetails) &&
          !utils.contactBelongsToBU(config.additivesTagId, foundDetails)
      "
      :contact="foundDetails"
    ></ContactFormGeneral>
    <ContactFormICS
      ref="icsForm"
      v-if="
        foundDetails && utils.contactBelongsToBU(config.icsTagId, foundDetails)
      "
      :contact="foundDetails"
    ></ContactFormICS>
    <ContactFormCatalysts
      ref="catalystsForm"
      v-if="
        foundDetails &&
          utils.contactBelongsToBU(config.catalystsTagId, foundDetails)
      "
      :contact="foundDetails"
    ></ContactFormCatalysts>
    <ContactFormAdditives
      ref="additivesForm"
      v-if="
        foundDetails &&
          utils.contactBelongsToBU(config.additivesTagId, foundDetails)
      "
      :contact="foundDetails"
    ></ContactFormAdditives>
    <div class="additional-fields">
      <input type="text" name="address" id="address-contact-wizard" />
      <input type="text" name="postal-code" id="postal-code-contact-wizard" />
    </div>
  </div>
</template>

<script>
import ServiceManager from "../services/service-manager";
import ContactFormGeneral from "./ContactFormGeneral.vue";
import ContactFormICS from "./ContactFormICS.vue";
import ContactFormCatalysts from "./ContactFormCatalysts.vue";
import ContactFormAdditives from "./ContactFormAdditives.vue";
import ContactCard from "./ContactCard.vue";
import { FlatButton } from "clariant-vue3-forms";

export default {
  name: "ContactForm",
  components: {
    ContactFormGeneral,
    ContactFormICS,
    ContactFormCatalysts,
    ContactFormAdditives,
    ContactCard,
    FlatButton,
  },
  props: [],
  data() {
    return {
      labels: ServiceManager.getService(this, "Labels"),
      config: ServiceManager.getService(this, "Config"),
      state: ServiceManager.getService(this, "State"),
      utils: ServiceManager.getService(this, "Utils"),
      dataLayer: ServiceManager.getService(this, "DataLayer"),
      foundDetails: null,
    };
  },
  setup() {
    return {
      uniqueId: `ContactForm-${Date.now().toString(36) + Math.random().toString(36).substring(2)}`
    }
  },
  mounted() {
    this.state.subscribe(
      this.uniqueId,
      this.onStateChanged
    );
    //this.loadContactDetails();
  },
  beforeUnmount() {
    this.state.unsubscribe(this.uniqueId);
  },
  methods: {
    getPrevStep() {
      return 0;
    },
    canAdvance() {
      return false;
    },
    getNextStep() {
      return 0;
    },
    loadContactDetails(forceContact) {
      let promise = null;
      let loader = this.utils.showLoader(".contact-form-container");
      if (forceContact)
        promise = this.dataLayer.getContactDetails(
          this.config.defaultContactId
        );
      else if (this.state.current.currentContact)
        promise = this.dataLayer.getContactDetails(
          this.state.current.currentContact
        );
      else if (this.state.current.currentProduct)
        promise = this.dataLayer.findContactByProduct(
          this.state.current.currentProduct,
          this.state.current.country,
          this.state.current.region
        );
      else if (this.state.current.bu || this.state.current.bl)
        promise = this.dataLayer.findContactByOrg(
          this.state.current.bu,
          this.state.current.bl,
          this.state.current.country,
          this.state.current.region
        );
      else
        promise = this.dataLayer.getContactDetails(
          this.config.defaultContactId
        );

      promise
        .then((res) => {
          if (!res.data) {
            this.loadContactDetails(this.config.defaultContactId);
          } else if (!Array.isArray(res.data)) {
            this.foundDetails = res.data;
          } else if (res.data.length < 1) {
            this.loadContactDetails(this.config.defaultContactId);
          } else {
            this.foundDetails = res.data[0];
          }
        })
        .catch((err) => {
          this.utils.showStatusMessage(
            `Could not load contact details. Error: ${err.message}.`,
            "red"
          );
        })
        .finally(() => {
          this.utils.removeLoader(loader);
        });
    },
    onStateChanged(message, prop, value) {
      if (!this.state.get("isReady")) return;
      if (prop === "country") {
        if (this.state.get("currentContact")) {
          console.log(
            `Country changed but contact is fixed. The contact remains unchanged.`
          );
        } else {
          console.log(`Country changed. Reloading contact.`);
          this.$nextTick(() => {
            this.loadContactDetails();
          });
        }
      } else if (message === "reload") {
        console.log(`Contact context changed. Reloading contact.`);
        this.$nextTick(() => {
          this.loadContactDetails();
        });
      }
    },
    onRewind() {
      this.$emit("rewind");
    },
    validateForm() {
      if (!this.foundDetails.id) {
        this.utils.showStatusMessage(
          "The contact person you requested could not be determined. Your request cannot be submitted.",
          "red"
        );
        return false;
      }
      return (
        (this.$refs.generalForm && this.$refs.generalForm.validateForm()) ||
        (this.$refs.icsForm && this.$refs.icsForm.validateForm()) ||
        (this.$refs.catalystsForm && this.$refs.catalystsForm.validateForm()) ||
        (this.$refs.additivesForm && this.$refs.additivesForm.validateForm())
      );
    },
    getFormPayload() {
      let form = this.$refs.generalForm ?? this.$refs.icsForm ?? this.$refs.catalystsForm ?? this.$refs.additivesForm;
      return form.getFormPayload();
    },
  },
};
</script>

<style scoped>
.intro {
  margin-bottom: 20px;
}

.contact-info {
  display: flex;
  margin-bottom: 20px;
  width: 100%;
  box-sizing: border-box;
  align-items: center;
}

.additional-fields {
  visibility: hidden;
}

.modal .different-contact,
.inline-contact-form-container .different-contact,
.inline-contact-form-container .intro {
  display: none;
}

.contact-form .cla-droplist-container .options-container {
  max-height: 170px;
}

@media all and (max-width: 700px) {
  .contact-info {
    flex-direction: column;
  }

  .contact-info > .contact {
    align-self: flex-start;
  }

  .contact-info .button {
    margin-top: 20px;
    height: auto;
  }
}
</style>
